import axios from 'axios';
import { ACCESS_TOKEN } from 'constant';

// LocalStorageService

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token && config.headers) {
      if (!config.headers['Content-Type'])
        config.headers['Content-Type'] = 'application/json';
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export { axios };
